module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Personvern",
	"footer.privacy.url": "https://www.grohe.no/no_no/personvaern.html",
	"footer.disclaimer.text": "Juridisk informasjon",
	"footer.disclaimer.url": "https://www.grohe.no/no_no/imprint.html",
	"footer.copyright": "&copy; 2017 GROHE Limited",
	"homepage.headline": "GROHE Vannsystemkonfigurator",
	"homepage.introtext": "Svar på noen få spørsmål under for å konfigurere hvilket GROHE vannsystem som passer deg og dine behov best.",
	"homepage.buttonStart": "Start",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Side ikke funnet",
	"404.link.goBack": "Gå tilbake til hjemmesiden",
	"configurator.button.seeResults": "Se resultater",
	"question1.question": "Har du kaldtvann- eller varmtvannstilførsel på ditt kjøkken?",
	"question1.option1.text": "Jeg har kaldt og varmt vanntilførsel på mitt kjøkken.",
	"question1.option2.text": "Jeg har kaldtvannstilførsel på mitt kjøkken.",
	"question2.question": "Hva slags vann er du ute etter??",
	"question2.option1.text": "Kokende varmt vann for forberedelse av mat og drikke.",
	"question2.option2.text": "Nedkjølt vann med kullsyre til å drikke.",
	"question2.option3.text": "Nedkjølt vann med kullsyre, men også kokende varmt vann.",
	"question3.question": "Ønsker du å beholde din allerede eksisterende kjøkkenkran?",
	"question3.option1.text": "Jeg ønsker å beholde den",
	"question3.option2.text": "Jeg ønsker å installere en ny modell",
	"question4.question": "Hvilken bør være din primære kjøkkenkran?",
	"question4.option1.text": "GROHE Blue Home",
	"question4.option2.text": "GROHE Red",
	"question5.question": "Hvilket tut-design foretrekker du?",
	"question5.option1.text": "L-formet tut",
	"question5.option2.text": "U-formet tut",
	"question5.option3.text": "C-formet tut",
	"question6.question": "Hvilket tut-design foretrekker du?",
	"question6.option1.text": "L-formet tut",
	"question6.option2.text": "U-formet tut",
	"question6.option3.text": "C-formet tut",
	"question7.question": "Hvilken er din foretrukne overflate??",
	"question7.option1.text": "Krom",
	"question7.option2.text": "Supersteel",
	"question8.question": "Hvilken størrelse trenger du på berederen?",
	"question8.option1.text": "M Størrelse (3 Liter)",
	"question8.option2.text": "L Størrelse (5.5 Liter)",
	"question9.question": "Would you like to have an additional filter to soften and enhance the water?",
	"question9.option1.text": "Yes",
	"question9.option2.text": "No",
	"question10.question": "Har du kaldtvann- eller varmtvannstilførsel på ditt kjøkken?",
	"question10.option1.text": "Jeg har kaldt og varmt vanntilførsel på mitt kjøkken.",
	"question10.option2.text": "Jeg har kaldtvannstilførsel på mitt kjøkken.",
	"results.title": "{productGroupsCount, plural, \none {Ditt resultat} \nother {Dine resultater}\n}",
	"results.proposal.title": "Proposal {number}",
	"results.proposal.title.single": "Proposal",
	"results.bundle.title": "For riktig installasjon trenger du også:",
	"results.newConfiguration.title": "Ønsker du å konfigurere et nytt vannsystem?",
	"results.newConfiguration.buttonText": "Konfigurer et nytt vannsystem",
	"results.product.number": "Produktnummer: #{number}",
	"results.product.button.productInformation": "Produktinformasjon",
	"results.product.button.dealerLocator": "Finn et showroom",
	"results.product.button.buyNow": "Buy Now",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": "Produktinformasjon",
	"results.product.dealer": "Find a showroom",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};


//////////////////
// WEBPACK FOOTER
// ./src/translations/water.no_no.json
// module id = 789
// module chunks = 0